import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";

import { MatDialog } from '@angular/material/dialog';
//import { ExportToCsv } from 'export-to-csv';
import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { HeatingSystem } from '../../types/heating-system';
import { LeadStatus } from '../../types/lead-status';
import { LeadDetails } from '../../types/leads';
import { ExportToCsv } from 'export-to-csv';

export interface Fuel {
    type: string;
    id: string;
}

export interface TrueFalse {
    type: boolean;
    name: string;
}

/**
 * @title Table with sticky columns
 */
@Component({
    selector: 'newleads-table',
    styleUrls: ['newleads-table.component.css'],
    templateUrl: 'newleads-table.component.html',
    providers: [HubService],
})
export class NewLeadsTableComponent implements OnInit {
    errorMessage: string;
    statusList = <LeadStatus[]>[];
    heatingSystemList = <HeatingSystem[]>[];
    leadList = <LeadDetails[]>[];
    loading_data: boolean;
    refresh_allowed: boolean;
    checkbox: number[] = [];
    totalUIDList: number[];
    Leadstype: string;

    tempString: string;
    tempDup: string;
    tempApp: string;
    tempWifi: string;
    temp2007: string;
    tempGrant: string;
    tempDead: string;
    tempRm: string;
    tempTime: string;
    checkAll: boolean = false;

    end_flag: boolean;

    @Output() rowCountEvent = new EventEmitter<string>();
    @Output() uidList = new EventEmitter<number[]>();
    searchParams = {} as LeadDetails;

    start_offset: number;
    end_offset: number;
    STEP = 200;
    INIT_SIZE = 500;
    LAST_POSITION = 0;

    fuels: Fuel[] = [
        { type: 'Oil', id: 'oil' },
        { type: 'Gas', id: 'gas' },
        { type: 'Other', id: 'other' }
    ];

    truefalse: TrueFalse[] = [
        { type: true, name: "true" },
        { type: false, name: "false" }
    ];

    constructor(
        private hubService: HubService,
        private matDialog: MatDialog,
    ) { }

    ngOnInit(): void {
        if (!AppComponent.IsLoggedIn()) { return; }

        this.start_offset = 0;
        this.loading_data = true;
        this.refresh_allowed = true;
        this.end_flag = false;

        var temp = {} as LeadDetails;
        this.leadList.push(temp);

        this.hubService.getLookupTable('lead_status').subscribe(
            lookup_values => this.statusList = <LeadStatus[]>lookup_values,
            error => this.errorMessage = <any>error,
        );
        this.hubService.getLookupTable('heating_system').subscribe(
            lookup_values => this.heatingSystemList = <HeatingSystem[]>lookup_values,
            error => this.errorMessage = <any>error,
        );

        this.Leadstype = "new";
        this.initalize(this.Leadstype, this.searchParams);
    }

    @ViewChild(CdkVirtualScrollViewport, { static: false })
    public viewPort: CdkVirtualScrollViewport;

    public get inverseOfTranslation(): string {
        if (!this.viewPort || !this.viewPort["_renderedContentOffset"]) {
            return "-0px";
        }
        let offset = this.viewPort["_renderedContentOffset"];
        return `-${offset}px`;
    }

    initalize(type: string, search: LeadDetails): void {
        this.start_offset = 0;

        if (this.searchParams.created) {
            this.searchParams.created = new Date(this.searchParams.created);
        }
        if (this.searchParams.handed_to_installer) {
            this.searchParams.handed_to_installer = new Date(this.searchParams.handed_to_installer);
        }
        if (this.searchParams.uid) {
            this.searchParams.uid = +this.searchParams.uid;
        }
        if (this.searchParams.installation_batch) {
            this.searchParams.installation_batch = +this.searchParams.installation_batch;
        }
        if (this.searchParams.lead_status_name) {
            for (var i = 0; i < this.statusList.length; ++i) {
                if (this.searchParams.lead_status_name.toLocaleLowerCase() == this.statusList[i].lead_status_name.toLocaleLowerCase()) {
                    this.searchParams.lead_status_id = this.statusList[i].lead_status_id;
                }
            }
        }
        if (this.searchParams.heating_system_name) {
            for (var i = 0; i < this.heatingSystemList.length; ++i) {
                if (this.searchParams.heating_system_name.toLocaleLowerCase() == this.heatingSystemList[i].heating_system_name.toLocaleLowerCase()) {
                    this.searchParams.heating_system_id = this.heatingSystemList[i].heating_system_id;
                }
            }
        }
        if (this.tempDup) {
            if (this.tempDup == "true") {
                this.searchParams.duplicate = true;
            } else {
                this.searchParams.duplicate = false;
            }
        }
        if (this.tempApp) {
            if (this.tempApp == "true") {
                this.searchParams.approved = true;
            } else {
                this.searchParams.approved = false;
            }
        }
        if (this.tempWifi) {
            if (this.tempWifi == "true") {
                this.searchParams.have_wifi = true;
            } else {
                this.searchParams.have_wifi = false;
            }
        }
        if (this.temp2007) {
            if (this.temp2007 == "true") {
                this.searchParams.built_before_2007 = true;
            } else {
                this.searchParams.built_before_2007 = false;
            }
        }
        if (this.tempGrant) {
            if (this.tempGrant == "true") {
                this.searchParams.previous_grant = true;
            } else {
                this.searchParams.previous_grant = false;
            }
        }
        if (this.tempDead) {
            if (this.tempDead == "true") {
                this.searchParams.dead_lead = true;
            } else {
                this.searchParams.dead_lead = false;
            }
        }
        if (this.tempRm) {
            if (this.tempRm == "true") {
                this.searchParams.removed = true;
            } else {
                this.searchParams.removed = false;
            }
        }
        if (this.tempTime) {
            if (this.tempTime == "true") {
                this.searchParams.use_time_clock = true;
            } else {
                this.searchParams.use_time_clock = false;
            }
        }

        try {
            this.loading_data = true;
            console.log("loading_data: ", this.loading_data);
            this.hubService.postLeads(type, this.start_offset, this.INIT_SIZE, search).subscribe(
                LeadDetails => {
                    if (LeadDetails.length < this.STEP) {
                        this.end_flag = true;
                    } else {
                        this.end_flag = false;
                    }
                    this.leadList = LeadDetails;
                    this.end_offset = this.INIT_SIZE;
                    if (LeadDetails.length == 0) {
                        var temp = {} as LeadDetails;
                        this.leadList.push(temp);
                    }
                    this.loading_data = false;
                },
                error => this.errorMessage = <any>error,
            );

            this.hubService.postLeadsCount(type, this.start_offset, this.INIT_SIZE, search, true).subscribe(
                LeadCount => this.rowCountEvent.emit(LeadCount.list[0]['count']),
                error => this.errorMessage = <any>error,
            );

            this.hubService.postLeadsUID(type, search).subscribe(
                uidTotal => {
                    this.totalUIDList = [];
                    for (var i = 0; i < uidTotal.list.length; i++) {
                        this.totalUIDList.push(+uidTotal.list[i]['uid'])
                    }
                },
                error => this.errorMessage = <any>error,
            );

        } catch (e) {
            console.log("error............")
            console.log('Meh: ' + e);
        }
    }

    refresh(type: string, step: any, down: boolean, event: any, search: LeadDetails): void {
        try {
            //    this.loading = true;
            console.log("refresh loading.........");
            var temp_offset;
            //Scrolling Down
            if (down) {
                temp_offset = this.end_offset;
            }
            //Scrolling Up
            if (!down) {
                temp_offset = this.start_offset;
            }

            event['srcElement']['scrollTop'] = event['srcElement']['scrollHeight'] / 2;

            this.hubService.postLeads(type, temp_offset, step, search).subscribe(
                LeadDetails => {
                    console.log("Pre Update length: " + this.leadList.length);
                    if (down) {
                        if (LeadDetails.length < this.STEP) {
                            this.end_flag = true;
                        } else {
                            this.end_flag = false;
                        }
                        var removed = this.leadList.splice(0, this.STEP);
                        this.leadList = this.leadList.concat(...LeadDetails);
                        this.end_offset += this.STEP;
                        this.start_offset = this.end_offset - this.INIT_SIZE - this.STEP;
                        console.log("Removed Down: " + removed.length + " Start: ", this.start_offset + " End: ", this.end_offset);
                    }

                    if (!down) {
                        var removed = this.leadList.splice((this.end_offset - this.INIT_SIZE), this.STEP);
                        this.leadList = LeadDetails.concat(this.leadList);
                        if (this.end_offset > this.INIT_SIZE) {
                            this.end_offset -= this.STEP;
                        }
                        if (this.start_offset != 0) {
                            this.start_offset = this.start_offset - this.STEP;
                        }
                        this.end_flag = false;
                        console.log("Removed Up: " + removed.length + " Start: ", this.start_offset + " End: ", this.end_offset);
                    }

                    console.log("Post Update length: " + this.leadList.length);
                    console.log("refresh loaded.........");
                    this.refresh_allowed = true;
                },
                error => this.errorMessage = <any>error,
            );
        } catch (e) {
            console.log("error............");
            console.log('Meh: ' + e);
        }
    }

    getColor(c: any): string {
        if (c % 2 == 0) {
            return "#dadada";
        } else {
            return "white"
        }
    }

    getName(c: any): string {
        if (c == "HES0005") {
            return "HES";
        } else if (c == "HUB001") {
            return "IES";
        } else {
            return "";
        }
    }

    scrolled(event: any): void {
        //console.log("--------------------------------");
        //console.log("ScrollTop" + event['srcElement']['scrollTop']);
        //console.log("ScrollHeight" + event['srcElement']['scrollHeight']);
        //console.log("--------------------------------");

        //Scroll Down
        if (this.LAST_POSITION < event['srcElement']['scrollTop']) {
            console.log("Scroll Down page");
            if (event['srcElement']['scrollTop'] > ((event['srcElement']['scrollHeight'] / 4) * 3)) {//3 *2
                if (this.refresh_allowed) {
                    this.refresh_allowed = false;
                    if (!this.end_flag) {
                        this.refresh(this.Leadstype, this.STEP, true, event, this.searchParams);
                    }
                } else {
                    console.log("NO REFRESH!!!");
                }
            }
        }
        //Scroll Up
        if (this.LAST_POSITION > event['srcElement']['scrollTop']) {
            console.log("Scroll Up page");
            if (event['srcElement']['scrollTop'] < ((event['srcElement']['scrollHeight'] / 4) * 1)) { // 6*1
                if (this.end_offset != this.INIT_SIZE) {
                    if (this.refresh_allowed) {
                        this.refresh_allowed = false;
                        this.refresh(this.Leadstype, this.STEP, false, event, this.searchParams);
                    } else {
                        console.log("NO REFRESH!!!");
                    }

                }

            }
        }
        this.LAST_POSITION = event['srcElement']['scrollTop'];


    }

    search() {
        //console.log(this.searchParams);
        this.initalize(this.Leadstype, this.searchParams);
    }

    cancel(id: string) {
        switch (id) {
            case 'uid':
                this.searchParams.uid = null;
                break;
            case 'email':
                this.searchParams.email = null;
                break;
            case 'duplicate':
                this.searchParams.duplicate = this.tempDup = null;
                break;
            case 'phone':
                this.searchParams.phone = null;
                break;
            case 'full_name':
                this.searchParams.full_name = null;
                break;
            case 'fuel_type':
                this.searchParams.fuel_type = null;
                break;
            case 'approved':
                this.searchParams.approved = this.tempApp = null;
                break;
            case 'comment':
                this.searchParams.comment = null;
                break;
            case 'source':
                this.searchParams.source = null;
                break;
            case 'address':
                this.searchParams.address = null;
                break;
            case 'postcode':
                this.searchParams.eircode = null;
                break;
            case 'city':
                this.searchParams.city = null;
                break;
            case 'created':
                this.searchParams.created = null;
                break;
            case 'batch':
                this.searchParams.installation_batch = null;
                break;
            case 'handed_to_installer':
                this.searchParams.handed_to_installer = null;
                break;
            case 'heatingsystem':
                this.searchParams.heating_system_id = this.searchParams.heating_system_name = null;
                break;
            case 'leadstatus':
                this.searchParams.lead_status_name = this.searchParams.lead_status_id = null;
                break;
            case 'dead':
                this.searchParams.dead_lead = this.tempDead = null;
                break;
            case 'removed':
                this.searchParams.removed = this.tempRm = null;
                break;
            case 'installer':
                this.searchParams.installer_name = null;
                break;
            case 'company_name':
                this.searchParams.installer_company_name = null;
                break;
            case 'wifi':
                this.searchParams.have_wifi = this.tempWifi = null;
                break;
            case 'pre2007':
                this.searchParams.built_before_2007 = this.temp2007 = null;
                break;
            case 'grant':
                this.searchParams.previous_grant = this.tempGrant = null;
                break;
            case 'timeclock':
                this.searchParams.use_time_clock = this.tempTime = null;
                break;
        }

        this.initalize(this.Leadstype, this.searchParams);
    }

    Add() {
        this.exportLeadsCSV();
        console.log(this.searchParams);
    }

    updateLeads(uid: number, update: any, event: any) {
        var leadsDetails = <LeadDetails[]>[];
        var tempLead = new LeadDetails;

        console.log(event);
        tempLead.uid = uid;
        switch (event) {
            case "next_email": {
                tempLead.email = update;
                break;
            }
            case "next_duplicate": {
                tempLead.duplicate = update;
                break;
            }
            case "next_phone": {
                tempLead.phone = update;
                break;
            }
            case "next_name": {
                tempLead.full_name = update;
                break;
            }
            case "next_comment": {
                tempLead.comment = update;
                break;
            }
            case "next_source": {
                tempLead.source = update;
                break;
            }
            case "next_address": {
                tempLead.address = update;
                break;
            }
            case "next_eircode": {
                tempLead.eircode = update;
                break;
            }
            case "next_city": {
                tempLead.city = update;
                break;
            }
            case "next_installation_batch": {
                tempLead.installation_batch = +update;
                break;
            }
            case "next_lead_status": {
                tempLead.lead_status_id = +update;
                break;
            }
            case "next_heating_system": {
                tempLead.heating_system_id = +update;
                break;
            }
            case "next_fuel_type": {
                tempLead.fuel_type = update;
                break;
            }
            case "next_approved": {
                tempLead.approved = update;
                tempLead.dead_lead = !update;
                break;
            }
            case "next_wifi": {
                tempLead.have_wifi = update;
                break;
            }
            case "next_pre2007": {
                tempLead.built_before_2007 = update;
                break;
            }
            case "next_grant": {
                tempLead.previous_grant = update;
                break;
            }
            case "next_timeclock": {
                tempLead.use_time_clock = update;
                break;
            }
            case "next_dead": {
                tempLead.dead_lead = update;
                break;
            }
            case "next_export_to_c": {
                tempLead.export_to_company = update;
                break;
            }
            case "next_handed_to_installer": {
                tempLead.handed_to_installer = new Date(update);
                break;
            }
            case "next_multiple_thermostats": {
                tempLead.multiple_thermostats = update;
                break;
            }
            case "next_installer": {
                tempLead.installer_name = update;
                break;
            }
            case "next_removed": {
                tempLead.removed = update;
                break;
            }
            case "next_installer_company_name": {
                tempLead.installer_name = update;
                break;
            }
        }

        leadsDetails.push(tempLead);
        console.log(leadsDetails);
        this.hubService.writeLeadsDetails(leadsDetails)
            .subscribe(
                data => console.log(data.status),
                error => this.errorMessage = <any>error,
            );
    }

    exportLeadsCSV(): void {
        let tempDate = new Date().toLocaleString();
        try {
            this.hubService.postLeadsCsv(this.checkbox).subscribe(
                leadsCsv => {
                    console.log(leadsCsv);
                    const options = {
                        filename: `Leads_${tempDate}`,
                        useKeysAsHeaders: true,
                    };
                    const csvExporter = new ExportToCsv(options);
                    csvExporter.generateCsv(leadsCsv);
                },
                error => this.errorMessage = <any>error,
            );
        } catch (e) {
            console.log('Meh: ' + e);
        }
    }

    masterBox(): void {
        if (!this.checkAll) {
            this.checkbox = [];
            this.uidList.emit(this.checkbox);
        } else {
            this.checkbox = [];
            this.checkbox = this.totalUIDList.slice(0);
            this.uidList.emit(this.checkbox);
        }
    }

    addId(id: any): void {
        var index = this.checkbox.findIndex(e => e == id)
        if (index == -1) {
            this.checkbox.push(+id);
        } else {
            this.checkAll = false;
            this.checkbox.splice(index, 1);
        }
        this.uidList.emit(this.checkbox);
    }

    checkForVal(id: any): boolean {
        if (this.checkAll) {
            return true
        }
        var index = this.checkbox.findIndex(e => e == id)
        if (index == -1) {
            return false;
        } else {
            return true;
        }
    }

    initalizeFromParent(): void {
        this.checkAll = false;
        this.masterBox();
        this.initalize(this.Leadstype, this.searchParams);
    }

    initalizeFromHeader(type: string): void {
        this.start_offset = 0;
        this.loading_data = true;
        this.Leadstype = type;
        this.checkAll = false;
        this.masterBox();
        this.initalize(this.Leadstype, this.searchParams);
    }


}


